var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNoTemplatesLarge = function SvgNoTemplatesLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "474px",
    height: "268px",
    viewBox: "0 0 237 134",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Empty State / Lake Mountain / Large Copy")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Message-Templates",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sf_WA_template_list_filled1",
    transform: "translate(-647.000000, -635.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "approved_templates",
    transform: "translate(262.000000, 511.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OpenRoad",
    transform: "translate(353.000000, 87.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-",
    fillOpacity: 0,
    fill: "#D8D8D8",
    x: 0,
    y: 0,
    width: 300,
    height: 200
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mountain1LightBlue",
    transform: "translate(50.000000, 87.500000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Mountain1LightBlueLine4",
    stroke: "#C2E8FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "11 37 56.5 0 89.5 30"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Mountain1LightBlueLine1",
    stroke: "#C2E8FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "79.5 19.5 91.5 9.5 125 37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9849503,30.9314364 C8.2694044,29.8647335 8.72942543,29.8603454 9.0150497,30.9314364 L10.5,36.5 L6.5,36.5 L7.9849503,30.9314364 Z",
    id: "Mountain1Tree3",
    fill: "#C2E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.97824634,28.8571906 C3.5425453,27.0030654 4.45756388,27.0034242 5.02175366,28.8571906 L7.5,37 L0.5,37 L2.97824634,28.8571906 Z",
    id: "Mountain1Tree2",
    fill: "#C2E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.289243,14.6322696 C103.681783,13.4546496 104.286782,13.4750581 104.637324,14.666902 L106.5,21 L102,18.5 L103.289243,14.6322696 Z",
    id: "Mountain1Tree1",
    fill: "#C2E8FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mountain2LightBlue",
    transform: "translate(226.500000, 115.000000) scale(-1, 1) translate(-226.500000, -115.000000) translate(195.000000, 105.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5574601,9.86621392 C3.07801051,8.00710531 3.92218178,8.00779206 4.4425399,9.86621392 L7,19 L0,19 L2.5574601,9.86621392 Z",
    id: "Mountain2Tree1",
    fill: "#C2E8FF",
    transform: "translate(3.500000, 13.313470) scale(-1, 1) translate(-3.500000, -13.313470) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0709498,11.6089382 C61.3079077,10.7203462 61.6929748,10.7236555 61.9335746,11.6259046 L62.8468782,15.0507934 L59.5,17.5 L61.0709498,11.6089382 Z",
    id: "Mountain2Tree2",
    fill: "#C2E8FF",
    transform: "translate(61.173439, 14.223843) scale(-1, 1) translate(-61.173439, -14.223843) "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Mountain2LightBlueLine4",
    stroke: "#C2E8FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "6 18.5 29.5 0 45.5 13.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Mountain2LightBlueLine1",
    stroke: "#C2E8FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "41 8.5 45.5 4.5 63 19"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RoadHorizonLine",
    transform: "translate(34.000000, 123.000000)",
    stroke: "#8CD3F8",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "RoadHorizonLineDarkBlue"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 1.5,
    x2: 233,
    y2: 1.5,
    id: "RoadHorizonLine4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155,
    y1: 2,
    x2: 222.5,
    y2: 31.5,
    id: "RoadHorizonLine3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 154,
    y1: 2,
    x2: 45.5,
    y2: 46.5,
    id: "RoadHorizonLine2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 1.5,
    x2: 3,
    y2: 1.5,
    id: "RoadHorizonLine1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Tree1",
    transform: "translate(80.926056, 105.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tree1LightBlue",
    transform: "translate(1.000000, 3.000000)",
    fill: "#C2E8FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7854673,0.725531723 L25.0955275,40.310556 C25.3989774,41.3726256 24.7839946,42.4795979 23.7219249,42.7830478 C23.5432412,42.8341005 23.3583142,42.8600006 23.1724803,42.8600006 L2.47540706,42.8600006 C1.37083756,42.8600006 0.475407062,41.9645701 0.475407062,40.8600006 C0.475407062,40.6741667 0.501307132,40.4892396 0.55235985,40.310556 L11.8624201,0.725531723 C12.014145,0.194496898 12.5676312,-0.112994509 13.098666,0.0387304412 C13.4308729,0.133647138 13.6905506,0.39332485 13.7854673,0.725531723 Z",
    id: "Tree1DarkBlueBkgd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tree1DarkBlue",
    stroke: "#8CD3F8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Tree1DarkBlueOutine",
    fill: "#C2E8FF",
    points: "13.5739437 0.360214956 27.0739437 46 0.073943662 46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5739437,5.5 C13.5739437,34.7486474 13.5739437,49.7486474 13.5739437,50.5 C13.5739437,49.7486474 13.5739437,34.7486474 13.5739437,5.5 Z",
    id: "Tree1DarkBlueLine3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.32394366,25.5 C10.9906103,29.039346 12.8239437,30.8726794 12.8239437,31 C12.8239437,30.8726794 10.9906103,29.039346 7.32394366,25.5 Z",
    id: "Tree1DarkBlueLine2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3239437,36.5 C19.3239437,31.3726794 21.8239437,28.8726794 21.8239437,29 C21.8239437,28.8726794 19.3239437,31.3726794 14.3239437,36.5 Z",
    id: "Tree1DarkBlueLine1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Tree2",
    transform: "translate(115.750000, 108.500000)",
    stroke: "#8CD3F8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tree2DarkBlue"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Tree2DarkBlueOutline1",
    fill: "#C2E8FF",
    points: "9.75 0.5 18.75 30 0.75 30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75,7 C9.75,24.9224349 9.75,34.0891016 9.75,34.5 C9.75,34.0891016 9.75,24.9224349 9.75,7 Z",
    id: "Tree2DarkBlueLine2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,18.1619718 C12.6666667,21.3925806 14,23.0592472 14,23.1619718 C14,23.0592472 12.6666667,21.3925806 10,18.1619718 Z",
    id: "Tree2DarkBlueLine1",
    transform: "translate(12.000000, 20.661972) scale(-1, 1) translate(-12.000000, -20.661972) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Tree3",
    transform: "translate(236.750000, 108.500000)",
    stroke: "#8CD3F8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tree3DarkBlue"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Tree3DarkBlueOutline1",
    fill: "#C2E8FF",
    points: "9.75 0.5 18.75 30 0.75 30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75,7 C9.75,24.9224349 9.75,34.0891016 9.75,34.5 C9.75,34.0891016 9.75,24.9224349 9.75,7 Z",
    id: "Tree3DarkBlueLine2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,18.1619718 C12.6666667,21.3925806 14,23.0592472 14,23.1619718 C14,23.0592472 12.6666667,21.3925806 10,18.1619718 Z",
    id: "Tree3DarkBlueLine1",
    transform: "translate(12.000000, 20.661972) scale(-1, 1) translate(-12.000000, -20.661972) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Cloud2",
    transform: "translate(118.000000, 67.748815)",
    stroke: "#C2E8FF",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cloud2LightBlue"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,8.79146919 L31.5,8.79146919 C31.1394857,6.06480614 32.0407715,3.78378292 34.2038574,1.94839955 C36.6877441,-0.0982417247 39.6367188,0.360587604 41.220459,1.06679965 C42.8041992,1.7730117 43.9803467,2.74328671 44.7956543,4.5741966 C45.1411133,5.34508018 45.3758952,5.99728321 45.5,6.53080569",
    id: "Cloud2LightBlueLine4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5,10.2985782 C42.0279134,8.46301559 43.1113688,7.26289664 44.7503662,6.69822136 C47.2088623,5.85120844 49.5400391,6.97920986 50.4711914,8.11420227 C51.4023438,9.24919468 51.6975098,10.1609662 51.873291,11.1124759 C51.9904785,11.7468158 52.0327148,12.4802559 52,13.3127962 L54.081543,13.3127962 C56.0183919,13.8295019 56.9937985,14.9811653 57.0077626,16.7677864 C57.0322678,19.9575033 54.6954577,20.7511848 53.5,20.7511848 L14,20.7511848",
    id: "Cloud2LightBlueLine3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 14.7511848,
    x2: 41.5002493,
    y2: 14.7511848,
    id: "Cloud2LightBlueLine2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 14.7511848,
    x2: 4,
    y2: 14.7511848,
    id: "Cloud2LightBlueLine1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Cloud1",
    transform: "translate(42.000000, 83.748815)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cloud1White",
    transform: "translate(40.000000, 10.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "CloudWhiteCover",
    points: "11.4575195 0.460169209 14.6577148 4.10763015 7.40527344 10.9552864 0.091796875 10.9552864"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Cloud1LightBlue",
    stroke: "#C2E8FF",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,8.79146919 L31.5,8.79146919 C31.1394857,6.06480614 32.0407715,3.78378292 34.2038574,1.94839955 C36.6877441,-0.0982417247 39.6367188,0.360587604 41.220459,1.06679965 C42.8041992,1.7730117 43.9803467,2.74328671 44.7956543,4.5741966 C45.1411133,5.34508018 45.3758952,5.99728321 45.5,6.53080569",
    id: "Cloud1LightBlueLine4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5,10.2985782 C42.0279134,8.46301559 43.1113688,7.26289664 44.7503662,6.69822136 C47.2088623,5.85120844 49.5400391,6.97920986 50.4711914,8.11420227 C51.4023438,9.24919468 51.6975098,10.1609662 51.873291,11.1124759 C51.9904785,11.7468158 52.0327148,12.4802559 52,13.3127962 L54.081543,13.3127962 C56.0183919,13.8295019 56.9937985,14.9811653 57.0077626,16.7677864 C57.0322678,19.9575033 54.6954577,20.7511848 53.5,20.7511848 L14,20.7511848",
    id: "Cloud1LightBlueLine3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 14.7511848,
    x2: 41.5002493,
    y2: 14.7511848,
    id: "Cloud1LightBlueLine2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 14.7511848,
    x2: 4,
    y2: 14.7511848,
    id: "Cloud1LightBlueLine1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Sun",
    transform: "translate(169.000000, 30.000000)",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "SunLightBlue",
    stroke: "#C2E8FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7804084,54.3739 C44.2068153,54.3739 54.2804084,44.2525647 54.2804084,31.7672649 C54.2804084,19.2819651 44.2068153,9.16062982 31.7804084,9.16062982 C19.3540015,9.16062982 9.28040839,19.2819651 9.28040839,31.7672649 C9.28040839,44.2525647 19.3540015,54.3739 31.7804084,54.3739 Z",
    id: "SunLightBlueOutline2",
    strokeDasharray: "67.5,0.5,0.5,9",
    transform: "translate(31.780408, 31.767265) rotate(230.000000) translate(-31.780408, -31.767265) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5785187,48.1853406 C40.6912171,48.1853406 48.0785187,40.763028 48.0785187,31.6071415 C48.0785187,22.451255 40.6912171,15.0289425 31.5785187,15.0289425 C22.4658203,15.0289425 15.0785187,22.451255 15.0785187,31.6071415 C15.0785187,40.763028 22.4658203,48.1853406 31.5785187,48.1853406 Z",
    id: "SunLightBlueOutline1",
    strokeDasharray: "53.5,5",
    transform: "translate(31.578519, 31.607142) rotate(150.000000) translate(-31.578519, -31.607142) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "SunDarkBlue",
    transform: "translate(19.000000, 19.000000)",
    fill: "#C2E8FF",
    stroke: "#8CD3F8"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "SunDarkBlueOutline",
    cx: 12.5,
    cy: 12.5592417,
    rx: 11,
    ry: 11.0592417
  })))))))));
};
export default SvgNoTemplatesLarge;